import { API_ENDPOINTS } from '../config/api';

/** Strip internal promotion sync markers from dose notes for display. */
export function sanitizeDoseNotesForDisplay(notes) {
  if (notes == null) return '';
  return String(notes)
    .split('\n')
    .filter((line) => !/^\s*\[promotionEvidenceId:\d+\]\s*$/.test(line))
    .join('\n')
    .trim();
}

export function doseHasPromotionEvidence(d) {
  return !!(d && d.promotionEvidencePath && String(d.promotionEvidencePath).trim());
}

export async function openVaccinationCardPromotionEvidence(evidencePath) {
  if (!evidencePath) return;
  try {
    const token = localStorage.getItem('token');
    const response = await fetch(`${API_ENDPOINTS.PROFILE_PICS}${evidencePath}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    window.open(url, '_blank');
  } catch (err) {
    console.error('Error opening vaccination evidence file:', err);
    alert('Failed to open file. Please try again.');
  }
}
